import { WebPlugin } from '@capacitor/core';
export class LunaSDKWeb extends WebPlugin {
    async initialize() {
        throw this.unimplemented('Not implemented on web.');
    }
    async start() {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map